export const entsiaDropDowns = {

  businessDescriptionsOptions: [
    {
      "value": "AGRICF",
      "label": "Agriculture - Farming",
      "automaticAction": "noAction"
    },
    {
      "value": "AIRCON",
      "label": "Air Conditioning Installers and Repairers",
      "automaticAction": "noAction"
    },
    {
      "value": "BUILDCON",
      "label": "Building Construction",
      "automaticAction": "noAction"
    },
    {
      "value": "BUSSCH",
      "label": "Bus - School / Local / Route Operator",
      "automaticAction": "noAction"
    },
    {
      "value": "BUSSHU",
      "label": "Bus - Shuttle / Airport Transfer",
      "automaticAction": "noAction"
    },
    {
      "value": "BUSTOUR",
      "label": "Bus - Tour Operator",
      "automaticAction": "noAction"
    },
    {
      "value": "CIVILCON",
      "label": "Civil Construction",
      "automaticAction": "noAction"
    },
    {
      "value": "CLEAN",
      "label": "Cleaning Contractors",
      "automaticAction": "noAction"
    },
    {
      "value": "COUN/GOV",
      "label": "Council, Government Body",
      "automaticAction": "noAction"
    },
    {
      "value": "CULTURAL",
      "label": "Cultural &amp; Recreational Services",
      "automaticAction": "noAction"
    },
    {
      "value": "DEMOL",
      "label": "Demolition",
      "automaticAction": "noAction"
    },
    {
      "value": "DRIVERT",
      "label": "Driver Training",
      "automaticAction": "referral"
    },
    {
      "value": "EARTHM",
      "label": "Earthmoving",
      "automaticAction": "noAction"
    },
    {
      "value": "EDUCATION",
      "label": "Education",
      "automaticAction": "noAction"
    },
    {
      "value": "ELECT",
      "label": "Electricians",
      "automaticAction": "noAction"
    },
    {
      "value": "EMERG",
      "label": "Emergency Services (Ambulance, Police, Fire, SES)",
      "automaticAction": "referral"
    },
    {
      "value": "ENGIN",
      "label": "Engineering",
      "automaticAction": "noAction"
    },
    {
      "value": "FILMT",
      "label": "Film, Television &amp; Broadcasting",
      "automaticAction": "referral"
    },
    {
      "value": "FININS",
      "label": "Finance &amp; Insurance",
      "automaticAction": "noAction"
    },
    {
      "value": "FREIGHTFOR",
      "label": "Freight Forwarding / Storage",
      "automaticAction": "noAction"
    },
    {
      "value": "GOLF",
      "label": "Golf Courses",
      "automaticAction": "noAction"
    },
    {
      "value": "HEALTH",
      "label": "Health &amp; Community Services",
      "automaticAction": "noAction"
    },
    {
      "value": "HOTEL",
      "label": "Hospitality",
      "automaticAction": "noAction"
    },
    {
      "value": "LANDF",
      "label": "Landfill &amp; Waste Recycling",
      "automaticAction": "noAction"
    },
    {
      "value": "LANDSC",
      "label": "Landscaping, Nursery",
      "automaticAction": "noAction"
    },
    {
      "value": "LAWNGARD",
      "label": "Lawn Care, Garden Maintenance, Turf Farms",
      "automaticAction": "noAction"
    },
    {
      "value": "MANUF",
      "label": "Manufacturing",
      "automaticAction": "noAction"
    },
    {
      "value": "MINING",
      "label": "Mining",
      "automaticAction": "referral"
    },
    {
      "value": "MOBMEC",
      "label": "Mobile Mechanic",
      "automaticAction": "noAction"
    },
    {
      "value": "DEALER",
      "label": "Motor/Plant/Motorcycle Dealer",
      "automaticAction": "noAction"
    },
    {
      "value": "PAINT",
      "label": "Painters",
      "automaticAction": "noAction"
    },
    {
      "value": "PLUMB",
      "label": "Plumbing",
      "automaticAction": "noAction"
    },
    {
      "value": "PROFESS",
      "label": "Professional Services (White Collar)",
      "automaticAction": "noAction"
    },
    {
      "value": "QUARRY",
      "label": "Quarry",
      "automaticAction": "referral"
    },
    {
      "value": "RENTAL",
      "label": "Rental / Hire Company",
      "automaticAction": "referral"
    },
    {
      "value": "RETAIL",
      "label": "Retail Trade",
      "automaticAction": "noAction"
    },
    {
      "value": "ROADM",
      "label": "Roadmaking",
      "automaticAction": "noAction"
    },
    {
      "value": "SITE",
      "label": "Site Preparation",
      "automaticAction": "noAction"
    },
    {
      "value": "SMASHMEC",
      "label": "Smash Repairer / Motor Mechanic",
      "automaticAction": "noAction"
    },
    {
      "value": "TOWTRUC",
      "label": "Tow Truck Operator",
      "automaticAction": "referral"
    },
    {
      "value": "TRAFF",
      "label": "Traffic Management",
      "automaticAction": "noAction"
    },
    {
      "value": "1TRANSFUE",
      "label": "Transport - Bulk Fuel/Gas/Diesel",
      "automaticAction": "referral"
    },
    {
      "value": "1TRANSFURN",
      "label": "Transport - Furniture Removalist",
      "automaticAction": "referral"
    },
    {
      "value": "1TRANSGEN",
      "label": "Transport - General",
      "automaticAction": "noAction"
    },
    {
      "value": "1TRANSLIV",
      "label": "Transport - Livestock",
      "automaticAction": "referral"
    },
    {
      "value": "1TRANSLOG",
      "label": "Transport - Logging",
      "automaticAction": "referral"
    },
    {
      "value": "1TRANSHAZ",
      "label": "Transport - Other Hazardous",
      "automaticAction": "referral"
    },
    {
      "value": "1TRANSREF",
      "label": "Transport - Refrigerated",
      "automaticAction": "referral"
    },
    {
      "value": "TREESE",
      "label": "Tree Services (Arborists, Green Waste)",
      "automaticAction": "referral"
    },
    {
      "value": "VACUUM",
      "label": "Vacuum Extraction",
      "automaticAction": "noAction"
    },
    {
      "value": "WHOLESALE",
      "label": "Wholesale Trade",
      "automaticAction": "noAction"
    }
  ],
  primaryGoodsOptions: [
    {
      "value": "AF",
      "label": "Animal Feed, Agricultural Supplies",
      "automaticAction": "referral"
    },
    {
      "value": "BS",
      "label": "Beer, Alcohol, Soft Drinks",
      "automaticAction": "noAction"
    },
    {
      "value": "BI",
      "label": "Bitumen, Tar, Hot Mix, Asphalt",
      "automaticAction": "referral"
    },
    {
      "value": "BT",
      "label": "Brick and Tile",
      "automaticAction": "noAction"
    },
    {
      "value": "BM",
      "label": "Building, Construction Materials, Plumbing Supplies, Scaffolding, Glass",
      "automaticAction": "noAction"
    },
    {
      "value": "BD",
      "label": "Bulk Milk",
      "automaticAction": "noAction"
    },
    {
      "value": "BU",
      "label": "Bus and Coach (Bus Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "CC",
      "label": "Car, Motor Cycle and Boat Carrier",
      "automaticAction": "referral"
    },
    {
      "value": "CV",
      "label": "Civil Engineering, Road, Contractors",
      "automaticAction": "referral"
    },
    {
      "value": "CT",
      "label": "Clothing and Accessories, Footwear",
      "automaticAction": "noAction"
    },
    {
      "value": "CL",
      "label": "Coal",
      "automaticAction": "referral"
    },
    {
      "value": "CA",
      "label": "Concrete Pumps",
      "automaticAction": "referral"
    },
    {
      "value": "CO",
      "label": "Containers",
      "automaticAction": "noAction"
    },
    {
      "value": "CR",
      "label": "Courier",
      "automaticAction": "referral"
    },
    {
      "value": "GB",
      "label": "Domestic Waste, Skip Bins",
      "automaticAction": "referral"
    },
    {
      "value": "DR",
      "label": "Drilling, Exploration",
      "automaticAction": "noAction"
    },
    {
      "value": "DT",
      "label": "Driver Training",
      "automaticAction": "referral"
    },
    {
      "value": "EM",
      "label": "Earthmoving Machinery (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "EL",
      "label": "Electrical and Electronic Equipment",
      "automaticAction": "noAction"
    },
    {
      "value": "EX",
      "label": "Express Post",
      "automaticAction": "noAction"
    },
    {
      "value": "FE",
      "label": "Fertiliser",
      "automaticAction": "referral"
    },
    {
      "value": "FU",
      "label": "Furniture (White and Brown Goods)",
      "automaticAction": "noAction"
    },
    {
      "value": "FR",
      "label": "Furniture Removalist",
      "automaticAction": "referral"
    },
    {
      "value": "GA",
      "label": "Garbage, Refuse, Waste (Other than Domestic)",
      "automaticAction": "referral"
    },
    {
      "value": "OT",
      "label": "General - Other Than as Specified",
      "automaticAction": "noAction"
    },
    {
      "value": "GC",
      "label": "General Non Hazardous (Other than as Specified)",
      "automaticAction": "noAction"
    },
    {
      "value": "GR",
      "label": "Grain, Cotton, Seed",
      "automaticAction": "noAction"
    },
    {
      "value": "HM",
      "label": "Hanging Meat",
      "automaticAction": "noAction"
    },
    {
      "value": "HA",
      "label": "Harvesting Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "HZ",
      "label": "Hazardous Bulk Fuel, Gas",
      "automaticAction": "referral"
    },
    {
      "value": "HO",
      "label": "Hazardous Chemical",
      "automaticAction": "referral"
    },
    {
      "value": "HN",
      "label": "Hazardous Explosive",
      "automaticAction": "referral"
    },
    {
      "value": "HZM",
      "label": "Hazardous Other Bulk > 500 Kgs/Lts",
      "automaticAction": "referral"
    },
    {
      "value": "HZG",
      "label": "Hazardous Other Packaged < 500 Kgs/Lts",
      "automaticAction": "noAction"
    },
    {
      "value": "HT",
      "label": "Hazardous Toxic",
      "automaticAction": "decline"
    },
    {
      "value": "LS",
      "label": "Livestock",
      "automaticAction": "noAction"
    },
    {
      "value": "LM",
      "label": "Logging Machinery (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "LG",
      "label": "Logging, Lumber",
      "automaticAction": "noAction"
    },
    {
      "value": "MA",
      "label": "Machinery, Tools and Equipment, Carrier",
      "automaticAction": "noAction"
    },
    {
      "value": "MI",
      "label": "Milling Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "MB",
      "label": "Mini Bus (Bus Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "ME",
      "label": "Mining Equipment (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "NM",
      "label": "Non-Earthmoving Machinery (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "PP",
      "label": "Non-Refrigerated Produce, Dry, Groceries, Bread",
      "automaticAction": "noAction"
    },
    {
      "value": "OD2",
      "label": "Over Dimensional (Excluding Machinery)",
      "automaticAction": "noAction"
    },
    {
      "value": "OD1",
      "label": "Over Dimensional (Machinery)",
      "automaticAction": "noAction"
    },
    {
      "value": "PA",
      "label": "Paper, Newspapers, Magazines",
      "automaticAction": "noAction"
    },
    {
      "value": "PC",
      "label": "Parcel Delivery (not courier)",
      "automaticAction": "noAction"
    },
    {
      "value": "CBA",
      "label": "Powder Cement and Manufactured, Concrete Items",
      "automaticAction": "noAction"
    },
    {
      "value": "RF",
      "label": "Refrigerated",
      "automaticAction": "noAction"
    },
    {
      "value": "RO",
      "label": "Roadmaking Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "SG",
      "label": "Sand, Soil, Gravel",
      "automaticAction": "noAction"
    },
    {
      "value": "SM",
      "label": "Scrap Metal, Steel, Other Metal",
      "automaticAction": "noAction"
    },
    {
      "value": "NA-CARS",
      "label": "Sedans, Utilities (Sedan Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "TT",
      "label": "Tow Trucks",
      "automaticAction": "referral"
    },
    {
      "value": "TL",
      "label": "Tree Lopper / Arborist",
      "automaticAction": "noAction"
    },
    {
      "value": "OD",
      "label": "Under Escort - Over Dimensional",
      "automaticAction": "noAction"
    },
    {
      "value": "VA",
      "label": "Vacuum Extraction - Non Destructive",
      "automaticAction": "noAction"
    },
    {
      "value": "WA",
      "label": "Water, Tallow, Cooking Oil",
      "automaticAction": "noAction"
    },
    {
      "value": "CB",
      "label": "Wet Cement / Concrete",
      "automaticAction": "referral"
    }
  ],
  primaryGoodsOtherOptions: [
    {
      "value": "AF",
      "label": "Animal Feed, Agricultural,Supplies"
    },
    {
      "value": "BS",
      "label": "Beer, Alcohol, Soft Drinks"
    },
    {
      "value": "BI",
      "label": "Bitumen, Tar, Hot Mix, Asphalt"
    },
    {
      "value": "BT",
      "label": "Brick and Tile"
    },
    {
      "value": "BM",
      "label": "Building, Construction Materials,,Plumbing Supplies, Scaffolding, Glass"
    },
    {
      "value": "BD",
      "label": "Bulk Milk"
    },
    {
      "value": "BU",
      "label": "Bus and Coach (Bus Class)"
    },
    {
      "value": "CC",
      "label": "Car, Motor Cycle and Boat,Carrier"
    },
    {
      "value": "CV",
      "label": "Civil Engineering, Road,Contractors"
    },
    {
      "value": "CT",
      "label": "Clothing and Accessories,,Footwear"
    },
    {
      "value": "CL",
      "label": "Coal"
    },
    {
      "value": "CA",
      "label": "Concrete Pumps"
    },
    {
      "value": "CO",
      "label": "Containers"
    },
    {
      "value": "CR",
      "label": "Courier"
    },
    {
      "value": "GB",
      "label": "Domestic Waste, Skip Bins"
    },
    {
      "value": "DR",
      "label": "Drilling, Exploration"
    },
    {
      "value": "DT",
      "label": "Driver Training"
    },
    {
      "value": "EM",
      "label": "Earthmoving Machinery (Plant,Class)"
    },
    {
      "value": "EL",
      "label": "Electrical and Electronic,Equipment"
    },
    {
      "value": "EX",
      "label": "Express Post"
    },
    {
      "value": "FE",
      "label": "Fertiliser"
    },
    {
      "value": "FU",
      "label": "Furniture (White and Brown,Goods)"
    },
    {
      "value": "FR",
      "label": "Furniture Removalist"
    },
    {
      "value": "GA",
      "label": "Garbage, Refuse, Waste (Other,than Domestic)"
    },
    {
      "value": "OT",
      "label": "General - Other Than as Specified"
    },
    {
      "value": "GC",
      "label": "General Non Hazardous (Other than,as Specified)"
    },
    {
      "value": "GR",
      "label": "Grain, Cotton, Seed"
    },
    {
      "value": "HM",
      "label": "Hanging Meat"
    },
    {
      "value": "HA",
      "label": "Harvesting Equipment (Plant,Class)"
    },
    {
      "value": "HZ",
      "label": "Hazardous Bulk Fuel, Gas"
    },
    {
      "value": "HO",
      "label": "Hazardous Chemical"
    },
    {
      "value": "HN",
      "label": "Hazardous Explosive"
    },
    {
      "value": "HZM",
      "label": "Hazardous Other Bulk,&gt;500Kgs/Lts"
    },
    {
      "value": "HZG",
      "label": "Hazardous Other Packaged &lt;500,Kgs/Lts"
    },
    {
      "value": "HT",
      "label": "Hazardous Toxic"
    },
    {
      "value": "LS",
      "label": "Livestock"
    },
    {
      "value": "LM",
      "label": "Logging Machinery (Plant Class)"
    },
    {
      "value": "LG",
      "label": "Logging, Lumber"
    },
    {
      "value": "MA",
      "label": "Machinery, Tools and Equipment,Carrier"
    },
    {
      "value": "MI",
      "label": "Milling Equipment (Plant Class)"
    },
    {
      "value": "MB",
      "label": "Mini Bus (Bus Class)"
    },
    {
      "value": "ME",
      "label": "Mining Equipment (Plant Class)"
    },
    {
      "value": "NM",
      "label": "Non-Earthmoving Machinery (Plant,Class)"
    },
    {
      "value": "PP",
      "label": "Non-Refrigerated Produce, Dry,Groceries, Bread"
    },
    {
      "value": "OD2",
      "label": "Over Dimensional (Excluding,Machinery)"
    },
    {
      "value": "OD1",
      "label": "Over Dimensional (Machinery)"
    },
    {
      "value": "PA",
      "label": "Paper, Newspapers, Magazines"
    },
    {
      "value": "PC",
      "label": "Parcel Delivery (not courier)"
    },
    {
      "value": "CBA",
      "label": "Powder Cement and Manufactured,Concrete Items"
    },
    {
      "value": "RF",
      "label": "Refrigerated"
    },
    {
      "value": "RO",
      "label": "Roadmaking Equipment (Plant,Class)"
    },
    {
      "value": "SG",
      "label": "Sand, Soil, Gravel"
    },
    {
      "value": "SM",
      "label": "Scrap Metal, Steel, Other Metal"
    },
    {
      "value": "NA-CARS",
      "label": "Sedans, Utilities (Sedan,Class)"
    },
    {
      "value": "TT",
      "label": "Tow Trucks"
    },
    {
      "value": "TL",
      "label": "Tree Lopper / Arborist"
    },
    {
      "value": "OD",
      "label": "Under Escort - Over Dimensional"
    },
    {
      "value": "VA",
      "label": "Vacuum Extraction - Non,Destructive"
    },
    {
      "value": "WA",
      "label": "Water, Tallow, Cooking Oil"
    },
    {
      "value": "CB",
      "label": "Wet Cement / Concrete"
    }
  ],
  timeInBusinessOptions: [
    {
      "value": "1",
      "label": "First year of operation"
    },
    {
      "value": "2",
      "label": "Second year of operation"
    },
    {
      "value": "3",
      "label": "Third year of operation"
    },
    {
      "value": "4",
      "label": "More than three years of operation"
    },
  ],
  radiusOfOperation: [
    {
      "value": "",
      "label": ""
    },
    {
      "value": "1",
      "label": "Up to 250 km"
    },
    {
      "value": "2",
      "label": "Over 250 km Up to 400 km"
    },
    {
      "value": "3",
      "label": "Over 400 km Up to 600 km"
    },
    {
      "value": "4",
      "label": "Over 600 km Up to 800 km"
    },
    {
      "value": "5",
      "label": "Over 800 km Up to 1000 km"
    },
    {
      "value": "6",
      "label": "Australia Wide"
    }],
  vehicleTypeOptions: [
    {
      "value": "9E",
      "label": "Bobcats/Skidsteer Loaders/Mini Excavators",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "BOX",
      "label": "Box Trailer",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "5J",
      "label": "Bus/Coach - Airport/Hotel Shuttle, Courtesy and NDIS",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "5I",
      "label": "Bus/Coach - Interstate Charter (>750km)",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "5G",
      "label": "Bus/Coach - Local Charter / School (100 to 300km)",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "5F",
      "label": "Bus/Coach - Local Route / School (<100km only)",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "5H",
      "label": "Bus/Coach - Short Charter (>300km)",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "9J",
      "label": "Cane Harvesting",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9F",
      "label": "Concrete Pumping Truck",
      "vehicleCanBeRegistered": true,
      "PE": false
    },
    {
      "value": "9H",
      "label": "Cotton, Grain & Hay Harvesting",
      "vehicleCanBeRegistered": true,
      "PE": false
    },
    {
      "value": "82",
      "label": "Dog Trailers - Flat Top",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "85",
      "label": "Dog Trailers - Livestock",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "81",
      "label": "Dog Trailers - Logging",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "84",
      "label": "Dog Trailers - Refrigerated",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "80",
      "label": "Dog Trailers - Side Tipper",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "86",
      "label": "Dog Trailers - Tanker / Pantech",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "83",
      "label": "Dog Trailers - Tipping",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "9N",
      "label": "Drilling Rigs - Truck & Track Mounted",
      "vehicleCanBeRegistered": true,
      "PE": false
    },
    {
      "value": "9B",
      "label": "Earthmoving Plant",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9K",
      "label": "Guidance Equipment",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9C",
      "label": "Logging Plant & Equipment",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9G",
      "label": "Milling Equipment",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9Q",
      "label": "Mobile Cranes",
      "vehicleCanBeRegistered": true,
      "PE": false
    },
    {
      "value": "9A",
      "label": "Non Earthmoving Plant (Forklift, ATV, Tractor etc.)",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "9I",
      "label": "Nut, Fruit & Vegetable Harvesting",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "3E",
      "label": "Prime Mover",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "9D",
      "label": "Quarry Plant / Open Cut Mining",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "3D",
      "label": "Rigid Trucks > 10 Tonne",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "3B",
      "label": "Rigid Trucks 2 - 5 Tonne / Refrigerated Van",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "3C",
      "label": "Rigid Trucks 5 - 10 Tonne",
      "vehicleCanBeRegistered": false,
      "PE": false
    },
    {
      "value": "9P",
      "label": "Roadmaking",
      "vehicleCanBeRegistered": true,
      "PE": true
    },
    {
      "value": "SE1",
      "label": "Sedan/4WD//Utility/Van (non-refrigerated)",
      "vehicleCanBeRegistered": false, 
      "PE": false
    },
    {
      "value": "96",
      "label": "Trailers - Dolly",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "89",
      "label": "Trailers - Flat Top / Tautliner / Skel",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "92",
      "label": "Trailers - Livestock",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "88",
      "label": "Trailers - Logging",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "91",
      "label": "Trailers - Refrigerated",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "94",
      "label": "Trailers - Side Tipper",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "87",
      "label": "Trailers - Sideloader",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "93",
      "label": "Trailers - Tanker / Pantech",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "90",
      "label": "Trailers - Tipping / Convertible",
      "vehicleCanBeRegistered": false,
      "PE": true
    },
    {
      "value": "95",
      "label": "Trailers - Walking Floor",
      "vehicleCanBeRegistered": false,
      "PE": true
    }
  ],
  freightTaskOptions: [
    {
      "value": "AN-ANIMAL",
      "label": "Animal Feed",
      "automaticAction": "referral"
    },
    {
      "value": "BS-BEERALC",
      "label": "Beer, Alcohol, Soft Drinks",
      "automaticAction": "noAction"
    },
    {
      "value": "BI-BITUMEN",
      "label": "Bitumen, Tar, Hot Mix, Asphalt",
      "automaticAction": "referral"
    },
    {
      "value": "BT-BRICK",
      "label": "Brick & Tile",
      "automaticAction": "noAction"
    },
    {
      "value": "BM-BLDCONS",
      "label": "Building & Construction Materials",
      "automaticAction": "noAction"
    },
    {
      "value": "HZ-BULKFUE",
      "label": "Bulk Fuel, Gas, Diesel",
      "automaticAction": "referral"
    },
    {
      "value": "BD-BLKMLK",
      "label": "Bulk Milk",
      "automaticAction": "noAction"
    },
    {
      "value": "BU-BUS",
      "label": "Bus & Coach (Bus Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "CC-CARCARR",
      "label": "Car & Boat Carrier (Excluding Tow Truck)",
      "automaticAction": "referral"
    },
    {
      "value": "CV-CIVIL",
      "label": "Civil Engineering, Road Contractors",
      "automaticAction": "referral"
    },
    {
      "value": "CT-CLOTH",
      "label": "Clothing & Accessories, Footwear",
      "automaticAction": "noAction"
    },
    {
      "value": "CL-COAL",
      "label": "Coal",
      "automaticAction": "referral"
    },
    {
      "value": "CA-CONCPMP",
      "label": "Concrete Pumps",
      "automaticAction": "noAction"
    },
    {
      "value": "CO-CONTAIN",
      "label": "Containers",
      "automaticAction": "noAction"
    },
    {
      "value": "CR-COURIER",
      "label": "Courier",
      "automaticAction": "referral"
    },
    {
      "value": "DR-DRILL",
      "label": "Drilling, Exploration",
      "automaticAction": "referral"
    },
    {
      "value": "DR-TRAIN",
      "label": "Driver Training",
      "automaticAction": "referral"
    },
    {
      "value": "EM-EARTHM",
      "label": "Earthmoving Machinery (Plant Class)",
      "automaticAction": "referral"
    },
    {
      "value": "EL-ELECT",
      "label": "Electrical & Electronic Equipment",
      "automaticAction": "noAction"
    },
    {
      "value": "EX-EXPRESS",
      "label": "Express Post",
      "automaticAction": "referral"
    },
    {
      "value": "FE-FERT",
      "label": "Fertiliser",
      "automaticAction": "noAction"
    },
    {
      "value": "FU-FURNDEL",
      "label": "Furniture Delivery of White & Brown Goods",
      "automaticAction": "noAction"
    },
    {
      "value": "FR-FURNREM",
      "label": "Furniture Removals",
      "automaticAction": "referral"
    },
    {
      "value": "GB-GARBDOM",
      "label": "Garbage Pickup of Domestic Waste",
      "automaticAction": "referral"
    },
    {
      "value": "GA-GARBAGE",
      "label": "Garbage/Waste",
      "automaticAction": "referral"
    },
    {
      "value": "GC-GENERAL",
      "label": "General Non-Hazardous",
      "automaticAction": "noAction"
    },
    {
      "value": "GR-GRAIN",
      "label": "Grain, Cotton, Seed",
      "automaticAction": "noAction"
    },
    {
      "value": "HM-HANGING",
      "label": "Hanging Meat",
      "automaticAction": "referral"
    },
    {
      "value": "HA-HARVEST",
      "label": "Harvesting Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "HO-HAZCHEM",
      "label": "Hazardous Chemical",
      "automaticAction": "referral"
    },
    {
      "value": "HN-HAZEXP",
      "label": "Hazardous Explosive",
      "automaticAction": "referral"
    },
    {
      "value": "HZM-HAZBUL",
      "label": "Hazardous Other Bulk >500Kgs/Lts",
      "automaticAction": "referral"
    },
    {
      "value": "HZG-HAZPAC",
      "label": "Hazardous Other Packaged <500 Kgs/Lts",
      "automaticAction": "noAction"
    },
    {
      "value": "HT-HAZTOXI",
      "label": "Hazardous Toxic",
      "automaticAction": "decline"
    },
    {
      "value": "LA-LAIDUP",
      "label": "Laid Up",
      "automaticAction": "noAction"
    },
    {
      "value": "LS-LIVESTO",
      "label": "Livestock",
      "automaticAction": "referral"
    },
    {
      "value": "LM-LOGMACH",
      "label": "Logging Machinery (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "LG-LOGGING",
      "label": "Logging, Lumber",
      "automaticAction": "referral"
    },
    {
      "value": "MA-MACH",
      "label": "Machinery & Equipment Carrier",
      "automaticAction": "noAction"
    },
    {
      "value": "MI-MILLING",
      "label": "Milling Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "MB-MINI",
      "label": "Mini Bus (Bus Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "ME-MINING",
      "label": "Mining Equipment (Plant Class)",
      "automaticAction": "decline"
    },
    {
      "value": "NM-NONEAR",
      "label": "Non-Earthmoving Machinery (Plant Class)",
      "automaticAction": "referral"
    },
    {
      "value": "OT-OTHER",
      "label": "Other",
      "automaticAction": "noAction"
    },
    {
      "value": "OD-OVERDIM",
      "label": "Over Dimensional",
      "automaticAction": "noAction"
    },
    {
      "value": "PA-PAPER",
      "label": "Paper",
      "automaticAction": "noAction"
    },
    {
      "value": "PD-PARCEL",
      "label": "Parcel Delivery (not courier)",
      "automaticAction": "noAction"
    },
    {
      "value": "CBA-CONC",
      "label": "Powder Cement & Manufactured Concrete Items",
      "automaticAction": "noAction"
    },
    {
      "value": "PP-PRODUCE",
      "label": "Produce Non-Refrigerated",
      "automaticAction": "noAction"
    },
    {
      "value": "RF-REFRIG",
      "label": "Refrigerated",
      "automaticAction": "referral"
    },
    {
      "value": "RO-ROAD",
      "label": "Roadmaking Equipment (Plant Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "SG-SAND",
      "label": "Sand, Soil, Gravel, Woodchip",
      "automaticAction": "noAction"
    },
    {
      "value": "SM-SCRAP",
      "label": "Scrap Metal, Steel, Other Metal",
      "automaticAction": "noAction"
    },
    {
      "value": "NA-CARS",
      "label": "Sedans, Utilities (Sedan Class)",
      "automaticAction": "noAction"
    },
    {
      "value": "TT-TOW",
      "label": "Tow Trucks",
      "automaticAction": "referral"
    },
    {
      "value": "TL-TREE",
      "label": "Tree Lopper, Arborist",
      "automaticAction": "referral"
    },
    {
      "value": "VA-VACUUM",
      "label": "Vacuum Extraction - Non-Destructive",
      "automaticAction": "noAction"
    },
    {
      "value": "WA-WATER",
      "label": "Water",
      "automaticAction": "noAction"
    },
    {
      "value": "CB-CEMENT",
      "label": "Wet Cement / Concrete",
      "automaticAction": "referral"
    }
  ],
  carModels: [
    {
      "Make": "Abarth",
      "Models": ["124", "500", "595", "695"]
    },
    {
      "Make": "Acura",
      "Models": ["CL", "ILX", "Integra", "MDX", "NSX", "RDX", "RL", "TL", "TSX", "ZDX"]
    },
    {
      "Make": "Alfa Romeo",
      "Models": ["1300", "147", "156", "159", "1600", "164", "1750", "2000", "33", "75", "90", "Alfasud", "Alfetta", "Berlina", "Brera", "Giulia", "Giulietta", "GT", "GTV", "MiTo", "Montreal", "Spider", "Sprint"]
    },
    {
      "Make": "Alpina",
      "Models": ["B3", "B4", "B5", "B6", "B7", "C1", "D3", "D4", "D5"]
    },
    {
      "Make": "Alpine",
      "Models": ["A110", "A310", "A610"]
    },
    {
      "Make": "AMC",
      "Models": ["AMX", "Concord", "Gremlin", "Hornet", "Javelin", "Matador", "Pacer", "Rambler"]
    },
    {
      "Make": "Aston Martin",
      "Models": ["Cygnet", "DB11", "DB7", "DB9", "DBS", "Lagonda", "Rapide", "V12 Vantage", "V8 Vantage", "Vanquish", "Virage", "Volante"]
    },
    {
      "Make": "Audi",
      "Models": ["100", "200", "80", "90", "A1", "A3", "A4", "A5", "A6", "A7", "A8", "e-tron", "Q2", "Q3", "Q5", "Q7", "Q8", "R8", "RS3", "RS4", "RS5", "RS6", "RS7", "S3", "S4", "S5", "S6", "S7", "S8", "TT"]
    },
    {
      "Make": "Austin",
      "Models": ["1800", "3 Litre", "A40", "Allegro", "Healey", "Kimberley", "Mini", "Princess", "Tasman"]
    },
    {
      "Make": "Austin Healey",
      "Models": ["100", "3000", "Sprite"]
    },
    {
      "Make": "Bentley",
      "Models": ["Arnage", "Azure", "Bentayga", "Brooklands", "Continental", "Eight", "Flying Spur", "Mulsanne", "Turbo R"]
    },
    {
      "Make": "Berkeley",
      "Models": ["328"]
    },
    {
      "Make": "BMW",
      "Models": ["1 Series", "2 Series", "3 Series", "4 Series", "5 Series", "6 Series", "7 Series", "8 Series", "i3", "i4", "i8", "M2", "M3", "M4", "M5", "M6", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "Z3", "Z4"]
    },
    {
      "Make": "Bolwell",
      "Models": ["IKARUS", "Nagari"]
    },
    {
      "Make": "Bugatti",
      "Models": ["Chiron", "EB110", "Veyron"]
    },
    {
      "Make": "Buick",
      "Models": ["Electra", "GS", "LeSabre", "Park Avenue", "Riviera", "Skylark", "Wildcat"]
    },
    {
      "Make": "BYD",
      "Models": ["Atto 3", "Dolphin", "Seal"]
    },
    {
      "Make": "Cadillac",
      "Models": ["ATS", "BLS", "CT4", "CT5", "CT6", "CTS", "DeVille", "Eldorado", "Escalade", "Fleetwood", "Seville", "SRX", "XLR"]
    },
    {
      "Make": "Chery",
      "Models": ["J1", "J3", "J11", "Tiggo 7 Pro", "Tiggo 8 Pro"]
    },
    {
      "Make": "Chevrolet",
      "Models": ["150", "210", "Bel Air", "Berlina", "Camaro", "Caprice", "Cavalier", "Chevelle", "Colorado", "Corvair", "Corvette", "Cruze", "Equinox", "Impala", "Malibu", "Monte Carlo", "Nova", "Spark", "SS", "Suburban", "Tahoe", "Trailblazer"]
    },
    {
      "Make": "Chrysler",
      "Models": ["300", "300C", "Charger", "Concorde", "Crossfire", "Neon", "PT Cruiser", "Sebring", "Valiant", "Voyager"]
    },
    {
      "Make": "Citroen",
      "Models": ["2CV", "AX", "Berlingo", "BX", "C1", "C2", "C3", "C3 Aircross", "C3 Picasso", "C4", "C4 Cactus", "C4 Picasso", "C5", "C5 Aircross", "C6", "C8", "DS3", "DS4", "DS5", "GS", "SAXO", "SM", "Xantia", "XM", "Xsara", "ZX"]
    },
    {
      "Make": "Dacia",
      "Models": ["Duster", "Logan", "Sandero"]
    },
    {
      "Make": "Daewoo",
      "Models": ["1.5i", "Cielo", "Espero", "Kalos", "Lacetti", "Lanos", "Leganza", "Matiz", "Nubira", "Tacuma"]
    },
    {
      "Make": "Daihatsu",
      "Models": ["Applause", "Charade", "Copen", "Cuore", "Delta", "Feroza", "Hijet", "Mira", "Move", "Pyzar", "Rocky", "Sirion", "Tarago", "Terios", "YRV"]
    },
    {
      "Make": "Datsun",
      "Models": ["1000", "1200", "1600", "180B", "200B", "240K", "240Z", "260Z", "280ZX", "300C", "Bluebird", "Cedric", "Cherry", "Fairlady", "Laurel", "Pulsar", "Silvia", "Skyline", "Stanza", "Sunny"]
    },
    {
      "Make": "Dodge",
      "Models": ["Avenger", "Caliber", "Challenger", "Charger", "Dakota", "Durango", "Journey", "Nitro", "RAM", "Viper"]
    },
    {
      "Make": "Daihatsu",
      "Models": ["Applause", "Charade", "Copen", "Cuore", "Delta", "Feroza", "Hijet", "Mira", "Move", "Pyzar", "Rocky", "Sirion", "Tarago", "Terios", "YRV"]
    },
    {
      "Make": "Ferrari",
      "Models": ["208", "246", "250", "275", "308", "328", "330", "348", "355", "360", "365", "400", "412", "456", "458", "488", "512", "550", "575", "599", "612", "812 Superfast", "California", "Daytona", "Enzo", "F12", "F40", "F50", "FF", "LaFerrari", "Mondial", "Portofino", "Roma", "Testarossa"]
    },
    {
      "Make": "Fiat",
      "Models": ["1100", "124", "125", "127", "128", "131", "500", "500C", "500L", "500X", "850", "Albea", "Argenta", "Bravo", "Brava", "Cinquecento", "Coupe", "Croma", "Doblo", "Ducato", "Fiorino", "Freemont", "Linea", "Marea", "Multipla", "Panda", "Punto", "Regata", "Ritmo", "Scudo", "Sedici", "Spider", "Stilo", "Strada", "Tipo", "Uno", "X1/9"]
    },
    {
      "Make": "Ford",
      "Models": ["200", "20M", "300", "500", "Capri", "Consul", "Cortina", "Cougar", "Courier", "Ecosport", "Escape", "Everest", "Falcon", "Fairlane", "Festiva", "Fiesta", "Focus", "Futura", "Galaxy", "Granada", "Kuga", "Laser", "Mondeo", "Mustang", "Probe", "Puma", "Ranger", "Sierra", "Spectron", "Telstar", "Territory", "Transit"]
    },
    {
      "Make": "GMC",
      "Models": ["Acadia", "Canyon", "Envoy", "Jimmy", "Safari", "Savana", "Sierra", "Sonoma", "Suburban", "Terrain", "Yukon"]
    },
    {
      "Make": "Great Wall",
      "Models": ["Cannon", "Deer", "Florid", "Hover", "Pegasus", "Peri", "Sailor", "Sing", "Steed", "V240", "X240"]
    },
    {
      "Make": "Haval",
      "Models": ["H1", "H2", "H3", "H5", "H6", "H8", "H9", "Jolion"]
    },
    {
      "Make": "Hillman",
      "Models": ["Avenger", "Hunter", "Imp", "Minx"]
    },
    {
      "Make": "Holden",
      "Models": ["Astra", "Barina", "Berlina", "Calais", "Camira", "Caprice", "Captiva", "Colorado", "Commodore", "Cruze", "Epica", "Gemini", "Jackaroo", "Kingswood", "Monaro", "Nova", "Rodeo", "Statesman", "Torana", "Trailblazer", "Ute", "Vectra", "Viva"]
    },
    {
      "Make": "Honda",
      "Models": ["Accord", "Civic", "Concerto", "CR-V", "CR-Z", "HR-V", "Insight", "Integra", "Jazz", "Legend", "Odyssey", "Prelude", "S2000"]
    },
    {
      "Make": "Hummer",
      "Models": ["H1", "H2", "H3"]
    },
    {
      "Make": "Hyundai",
      "Models": ["Accent", "Elantra", "Excel", "Getz", "i20", "i30", "i40", "Ioniq", "Kona", "Lantra", "Santa Fe", "Sonata", "Staria", "Terracan", "Tiburon", "Trajet", "Tucson", "Veloster", "Venue"]
    },
    {
      "Make": "Infiniti",
      "Models": ["EX", "FX", "G", "JX", "M", "Q30", "Q40", "Q50", "Q60", "Q70", "QX30", "QX50", "QX56", "QX60", "QX70", "QX80"]
    },
    {
      "Make": "Isuzu",
      "Models": ["Amigo", "Bighorn", "D-Max", "Gemini", "MU-X", "Piazza", "Rodeo", "Stylus", "Trooper", "VehiCROSS"]
    }
    ,
    {
      "Make": "Jaguar",
      "Models": ["240", "340", "420", "E-PACE", "E-TYPE", "F-PACE", "F-TYPE", "I-PACE", "S-TYPE", "X-TYPE", "XE", "XF", "XJ", "XJR", "XJS", "XK", "XKR"]
    },
    {
      "Make": "Jeep",
      "Models": ["Cherokee", "Commander", "Compass", "Gladiator", "Grand Cherokee", "Patriot", "Renegade", "Wrangler"]
    },
    {
      "Make": "Jensen",
      "Models": ["Healey", "Interceptor"]
    },
    {
      "Make": "JMC",
      "Models": ["Vigus"]
    },
    {
      "Make": "Kia",
      "Models": ["Carnival", "Cerato", "EV6", "K2700", "Magentis", "Optima", "Picanto", "Rio", "Seltos", "Sorento", "Soul", "Sportage", "Stinger"]
    },
    {
      "Make": "KTM",
      "Models": ["X-BOW"]
    },
    {
      "Make": "Lada",
      "Models": ["Niva", "Samara", "Volante"]
    },
    {
      "Make": "Lamborghini",
      "Models": ["Aventador", "Countach", "Diablo", "Gallardo", "Huracan", "Murcielago", "Urus"]
    },
    {
      "Make": "Lancia",
      "Models": ["Beta", "Dedra", "Delta", "Flaminia", "Flavia", "Fulvia", "Thema", "Ypsilon"]
    },
    {
      "Make": "Land Rover",
      "Models": ["Defender", "Discovery", "Discovery Sport", "Freelander", "Range Rover", "Range Rover Evoque", "Range Rover Sport", "Range Rover Velar"]
    },
    {
      "Make": "LDV",
      "Models": ["D90", "Deliver 9", "G10", "T60", "V80"]
    },
    {
      "Make": "Lexus",
      "Models": ["CT", "ES", "GS", "IS", "LC", "LFA", "LS", "LX", "NX", "RC", "RX", "SC", "UX"]
    },
    {
      "Make": "Leyland",
      "Models": ["Marina", "Mini", "Moke", "P76"]
    },
    {
      "Make": "Lightburn",
      "Models": ["Zeta"]
    },
    {
      "Make": "Lincoln",
      "Models": ["Aviator", "Continental", "Corsair", "MKC", "MKS", "MKT", "MKX", "MKZ", "Navigator", "Nautilus"]
    },
    {
      "Make": "Lotus",
      "Models": ["Elan", "Elise", "Emira", "Esprit", "Evora", "Exige"]
    }
    ,
    {
      "Make": "Mahindra",
      "Models": ["Bushranger", "Genio", "PIK-UP", "Stockman", "XUV500"]
    },
    {
      "Make": "Maserati",
      "Models": ["222", "228", "3200GT", "430", "Biturbo", "Coupe", "Ghibli", "GranCabrio", "Gransport", "GranTurismo", "Karif", "Khamsin", "Kyalami", "Levante", "Merak", "Quattroporte", "Shamal", "Spyder"]
    },
    {
      "Make": "Maybach",
      "Models": ["57", "62"]
    },
    {
      "Make": "Mazda",
      "Models": ["1000", "1200", "121", "121L", "1300", "1500", "1800", "2", "2000", "2200", "3", "323", "6", "600", "626", "800", "808", "929", "929l", "B1500", "B1600", "B1800", "B2000", "B2200", "B2600", "Bongo", "Bravo", "BT-50", "Capella", "Capella RX-2", "Cosmo", "CX-3", "CX-30", "CX-5", "CX-7", "CX-8", "CX-9", "E1300", "E1400", "E1600", "E1800", "E2000", "E2200", "E2500", "Eunos 30X", "Eunos 500", "Eunos 800", "Familia", "Millenia", "MPV", "MX-5", "MX-6", "Premacy", "R100", "RX-3", "RX-4", "RX-5", "RX-7", "RX-8", "Tribute"]
    },
    {
      "Make": "McLaren",
      "Models": ["540C", "570GT", "570S", "600LT", "650S", "675LT", "720S", "MP4-12C"]
    },
    {
      "Make": "Mercedes-Benz",
      "Models": ["180E", "190", "190B", "190C", "190D", "190DB", "190DC", "190E", "190SL", "200", "200D", "220", "220D", "220E", "220S", "220SE", "230", "230E", "230GE", "230S", "230SL", "230TE", "240D", "250", "250C", "250CE", "250S", "250SE", "250SL", "260E", "280", "280CE", "280E", "280S", "280SE", "280SEL", "280SL", "280SLC", "280TE", "300", "300CE", "300CE-24", "300D", "300E", "300GD", "300SE", "300SEL", "300SL", "300TD", "300TE", "320CE", "320E", "350SE", "350SEL", "350SL", "350SLC", "380SE", "380SEC", "380SEL", "380SL", "400SE", "400SEL", "420SE", "420SEL", "450SE", "450SEL", "450SL", "450SLC", "500SEC", "500SEL", "500SL", "560SEC", "560SEL", "560SL", "600", "600SEL", "600SL", "A-Class", "AMG GT", "B-Class", "C-Class", "CLA-Class", "CLC-Class", "CL-Class", "CLK-Class", "CLS-Class", "E-Class", "EQC", "G-Class", "GL-Class", "GLA-Class", "GLC-Class", "GLE-Class", "GLS-Class", "Marco Polo ACTIVITY", "MB100", "MB140", "M-Class", "R-Class", "S-Class", "SLC-Class", "SL-Class", "SLK-Class", "SLS-Class", "Sprinter", "Valente", "V-Class", "Viano", "Vito", "X-Class"]
    },
    {
      "Make": "MG",
      "Models": ["A", "B", "F", "GS", "HS", "Magnette", "MG3", "MG6", "MG6 PLUS", "Midget", "TF", "ZR", "ZS", "ZT"]
    },
    {
      "Make": "MINI",
      "Models": ["Cabrio", "Clubman", "Convertible", "Countryman", "Coupe", "Hatch", "Paceman", "Roadster"]
    },
    {
      "Make": "Mitsubishi",
      "Models": ["3000GT", "380", "Airtrek", "ASX", "Challenger", "Colt", "Cordia", "D50 Express", "Delica", "Eclipse Cross", "Express", "FTO", "Galant", "Grandis", "GTO", "i-MiEV", "Lancer", "Legnum", "Magna", "Mirage", "Nimbus", "Outlander", "Pajero", "Pajero iO", "Pajero Sport", "Ralliart Evo", "Ralliart Magna", "RVR", "Sigma", "Sigma Scorpion", "Starion", "Starwagon", "Triton", "Verada"]
    },
    {
      "Make": "Morgan",
      "Models": ["3 Wheeler", "43559", "AERO", "AERO 8", "Plus 4", "PLUS 8", "Roadster", "Runabout"]
    },
    {
      "Make": "Morris",
      "Models": ["1100", "1300", "1500", "850", "Major", "Mini", "Mini Clubman", "Mini Cooper", "Minor", "Moke", "Oxford"]
    },
    {
      "Make": "Nissan",
      "Models": ["1200", "180SX", "200B", "200SX", "280C", "280ZX", "300C", "300ZX", "350Z", "370Z", "720", "Almera", "Altima", "Bluebird", "C20", "Cedric", "Cefiro", "Cube", "Dualis", "E20", "Elgrand", "Exa", "Gazelle", "GT-R", "Infiniti", "JUKE", "Largo", "LEAF", "Maxima", "Micra", "Murano", "Navara", "Nomad", "NX", "Pathfinder", "Patrol", "Pintara", "Prairie", "Pulsar", "QASHQAI", "S Cargo", "Serena", "Silvia", "Skyline", "Stagea", "Stanza", "Sunny", "Terrano II", "The Ute", "Tiida", "Urvan", "Vanette", "X-TRAIL"]
    },
    {
      "Make": "Noble",
      "Models": ["M12"]
    },
    {
      "Make": "NSU",
      "Models": ["Prinz", "Ro 80"]
    },
    {
      "Make": "Opel",
      "Models": ["Astra", "Corsa", "Insignia", "Zafira"]
    },
    {
      "Make": "Pagani",
      "Models": ["Zonda"]
    },
    {
      "Make": "Peugeot",
      "Models": ["2008", "205", "206", "207", "208", "3008", "306", "307", "308", "4007", "4008", "403", "404", "405", "406", "407", "408", "504", "505", "508", "5008", "604", "605", "607", "Boxer", "Expert", "Partner", "RCZ"]
    },
    {
      "Make": "Pontiac",
      "Models": ["Firebird", "Laurentian", "Parisienne"]
    },
    {
      "Make": "Porsche",
      "Models": ["356B", "356C", "356SC", "718", "911", "912", "924", "928", "930", "944", "968", "Boxster", "Cayenne", "Cayman", "Macan", "Panamera"]
    },
    {
      "Make": "Proton",
      "Models": ["Exora", "Gen 2", "Jumbuck", "M21", "Persona", "Preve", "S16", "Satria", "Savvy", "Suprima S", "Waja", "Wira"]
    },
    {
      "Make": "RAM",
      "Models": ["1500", "2500", "3500"]
    },
    {
      "Make": "Rambler",
      "Models": ["AMX", "American 330", "American 440", "Classic", "Classic 660 V8", "Hornet", "Javelin", "Matador", "Rebel"]
    },
    {
      "Make": "Renault",
      "Models": ["1.4", "10", "12", "15", "16", "17", "18", "19", "20", "21", "25", "4", "750", "Captur", "Caravelle", "Clio", "Dauphine", "Floride", "Fluence", "Fuego", "Grand scenic", "Kadjar", "Kangoo", "Koleos", "Laguna", "Latitude", "Master", "Megane", "Scenic", "Scenic RX4", "Trafic", "Virage", "Zoe"]
    },
    {
      "Make": "Robnell",
      "Models": ["302SC", "429SC"]
    },
    {
      "Make": "Rolls-Royce",
      "Models": ["Camargue", "Corniche", "Cullinan", "Dawn", "Flying Spur", "Ghost", "Park Ward", "Phantom", "Silver Cloud", "Silver Dawn", "Silver Seraph", "Silver Shadow", "Silver Spirit", "Silver Spur", "Wraith"]
    },
    {
      "Make": "Rover",
      "Models": ["2000", "3 Litre", "3.5 LT", "3500", "416i", "75", "825", "827", "Quintet"]
    },
    {
      "Make": "Saab",
      "Models": ["99", "900", "9000", "900i", "43711", "43713"]
    },
    {
      "Make": "Seat",
      "Models": ["Cordoba", "Ibiza", "Toledo"]
    },
    {
      "Make": "Simca",
      "Models": ["Aronde", "Vedette"]
    },
    {
      "Make": "Skoda",
      "Models": ["120L", "Fabia", "Karoq", "Kodiaq", "Octavia", "Rapid", "Roomster", "S100", "S110", "S120L", "Superb", "Yeti"]
    },
    {
      "Make": "Smart",
      "Models": ["Cabrio", "City-Coupe", "Forfour", "Fortwo", "Roadster"]
    },
    {
      "Make": "SsangYong",
      "Models": ["Actyon", "Actyon Sports", "Chairman", "Korando", "Kyron", "Musso", "Rexton", "Stavic", "Tivoli", "Tivoli XLV"]
    },
    {
      "Make": "Studebaker",
      "Models": ["Hawk", "Lark"]
    },
    {
      "Make": "Subaru",
      "Models": ["1400", "1600", "BRZ", "Brumby", "Fiori", "Forester", "Impreza", "L Series", "Leone", "Levorg", "Liberty", "Outback", "Sherpa", "Sportswagon", "SVX", "Tribeca", "Vortex", "WRX", "XV"]
    },
    {
      "Make": "Suzuki",
      "Models": ["Alto", "APV", "Baleno", "Cappuccino", "Carry", "Celerio", "Cultus", "Grand Vitara", "Hatch", "Ignis", "Jimny", "Kizashi", "Liana", "LJ50", "LJ50V", "LJ80", "LJ80V", "LJ81K", "Mighty Boy", "S-Cross", "Sierra", "Swift", "SX4", "Vitara", "Wagon R+", "X-90", "XL-7"]
    },
    {
      "Make": "Tata",
      "Models": ["Safari", "Telcoline", "Xenon"]
    },
    {
      "Make": "TD 2000",
      "Models": ["TD 2000"]
    },
    {
      "Make": "Tesla",
      "Models": ["Model 3", "Model S", "Model X", "Roadster"]
    },
    {
      "Make": "Toyota",
      "Models": ["4Runner", "700", "86", "Aristo", "Aurion", "Avalon", "Avensis Verso", "Blizzard", "C-HR", "Caldina", "Camry", "Camry Vienta", "Carina", "Celica", "Chaser", "Corolla", "Corona", "Corona Avante", "Corsa", "Cressida", "Cresta", "Crown", "Cynos", "Echo", "Estima", "FJ Cruiser", "Fortuner", "Granvia", "Hiace", "Hiace SBV", "Hilux", "Hilux 4Runner", "Hilux Surf", "Kluger", "Landcruiser", "Landcruiser Prado", "Lexcen", "Liteace", "Mark II", "Masterace", "MR2", "Paseo", "Prius", "Prius C", "Prius V", "RAV4", "Rukus", "Sera", "Soarer", "Spacia", "Sprinter", "Starlet", "Stout", "Supra", "T-18", "Tarago", "Tercel", "Tiara", "Townace", "Vienta", "Yaris"]
    },
    {
      "Make": "TRD",
      "Models": ["Aurion", "Hilux"]
    },
    {
      "Make": "Triumph",
      "Models": ["2.5", "2000", "2500", "18598", "Dolomite", "GT6", "Herald", "Spitfire", "Stag", "TR3A", "TR4", "TR4A", "TR5", "TR6", "TR7"]
    },
    {
      "Make": "TVR",
      "Models": ["Chimaera", "Griffith"]
    },
    {
      "Make": "Vanden Plas",
      "Models": ["Princess", "Princess 1100"]
    },
    {
      "Make": "Vauxhall",
      "Models": ["Cresta", "Velox", "Victor", "Viva", "VX 4/90"]
    },
    {
      "Make": "Volkswagen",
      "Models": ["1500", "1600", "Amarok", "Arteon", "Beetle", "Bora", "Caddy", "Caravelle", "CC", "Country", "Crafter", "Eos", "Golf", "Jetta", "Karmann Ghia", "Kombi", "Kombi Transporter", "LT", "Microbus", "Multivan", "Passat", "Polo", "Scirocco", "Superbug", "Tiguan", "Touareg", "Transporter", "up!", "Vento"]
    },
    {
      "Make": "Volvo",
      "Models": ["122S", "123", "124", "125", "142", "144", "145", "164", "240", "242", "244", "245", "262", "264", "265", "360", "440", "740", "760", "850", "940", "960", "C30", "C70", "Cross Country", "P1800", "S40", "S60", "S70", "S80", "S90", "V40", "V40 Cross Country", "V50", "V60", "V60 Cross Country", "V70", "V90", "V90 Cross Country", "XC40", "XC60", "XC70", "XC90"]
    },
    {
      "Make": "Wolseley",
      "Models": ["15/60", "24/80", "36312", "6/110"]
    },
    {
      "Make": "ZX Auto",
      "Models": ["Grand Tiger"]
    }
  ],
  reasonsNotInsured: [{
    "value": "",
    "label": ""
  }, {
    "value": "1",
    "label": "New/recent purchased vehicles"
  }, {
    "value": "2",
    "label": "Self-insured"
  }, {
    "value": "3",
    "label": "Pre-existing damage"
  }, {
    "value": "4",
    "label": "Declined by prior insurer"
  }],
  currentInsurers: [
    { "value": "", "label": "" },
    { "value": "INS00081", "label": "360 Underwriting" },
    { "value": "INS00061", "label": "AAMI" },
    { "value": "INS00085", "label": "Achmea" },
    { "value": "INS00020", "label": "Allianz" },
    { "value": "INS00050", "label": "Alltrans" },
    { "value": "INS00080", "label": "Armada" },
    { "value": "INS00074", "label": "ATC Insurance Solutions" },
    { "value": "INS00071", "label": "ATL" },
    { "value": "INS00057", "label": "Australian Bus & Coach" },
    { "value": "INS00048", "label": "Austruck" },
    { "value": "INS00088", "label": "Blue Zebra" },
    { "value": "INS00068", "label": "Calliden" },
    { "value": "INS00052", "label": "Cemac" },
    { "value": "INS00021", "label": "CGU" },
    { "value": "INS00078", "label": "Chase" },
    { "value": "INS00076", "label": "Dawes" },
    { "value": "INS00053", "label": "Elders" },
    { "value": "INS00082", "label": "eSentry" },
    { "value": "INS00022", "label": "Fleetsure/Comm & Trucksure" },
    { "value": "INS00023", "label": "GIO" },
    { "value": "INS00024", "label": "GT" },
    { "value": "INS00089", "label": "Guild" },
    { "value": "INS00090", "label": "HDI Global" },
    { "value": "INS00067", "label": "HMIA" },
    { "value": "INS00025", "label": "Hollard" },
    { "value": "INS00026", "label": "IAG" },
    { "value": "INS00070", "label": "Insuret" },
    { "value": "INS00027", "label": "JUA" },
    { "value": "INS00083", "label": "Key Underwriting" },
    { "value": "INS00062", "label": "LLoyds" },
    { "value": "INS00047", "label": "Lumley" },
    { "value": "INS00059", "label": "Mecon" },
    { "value": "INS00087", "label": "Millenium Underwriting" },
    { "value": "INS00055", "label": "NRMA" },
    { "value": "INS00028", "label": "NTI" },
    { "value": "INS00075", "label": "One Underwriting" },
    { "value": "INS00066", "label": "Pen" },
    { "value": "INS00029", "label": "QBE" },
    { "value": "INS00030", "label": "RAA" },
    { "value": "INS00031", "label": "RAC" },
    { "value": "INS00032", "label": "RACQ" },
    { "value": "INS00033", "label": "RACT" },
    { "value": "INS00034", "label": "Savannah" },
    { "value": "INS00056", "label": "SGIC" },
    { "value": "INS00079", "label": "Shannons" },
    { "value": "INS00035", "label": "SRS" },
    { "value": "INS00036", "label": "SUA" },
    { "value": "INS00037", "label": "Suncorp" },
    { "value": "INS00073", "label": "SURA" },
    { "value": "INS00077", "label": "Taxi Mutual" },
    { "value": "INS00043", "label": "TIO" },
    { "value": "INS00044", "label": "Transcorp" },
    { "value": "INS00049", "label": "UAA" },
    { "value": "INS00045", "label": "Unknown" },
    { "value": "VARIOUS", "label": "Various" },
    { "value": "INS00051", "label": "Vero" },
    { "value": "INS00065", "label": "W R Berkley" },
    { "value": "INS00054", "label": "Wesfarmers" },
    { "value": "INS00072", "label": "YOUI" },
    { "value": "INS00046", "label": "Zurich" }
  ],
  dangerousGoodsLimit: [
    { value: '', label: '' },
    //{ value: '3', label: '$2,500,000' },
    { value: '4', label: '$5,000,000' },
    { value: '5', label: '$10,000,000' },
    { value: '6', label: '$15,000,000' },
    { value: '7', label: '$20,000,000' },
    { value: '8', label: '$25,000,000' },
    { value: '9', label: '$30,000,000' }
  ],
  dangerousGoodsClasses: [
    { "value": "", label: "" },
    { "value": "1.1", label: "1.1" },
    { "value": "1.2", label: "1.2" },
    { "value": "1.3", label: "1.3" },
    { "value": "1.4", label: "1.4" },
    { "value": "1.5", label: "1.5" },
    { "value": "1.6", label: "1.6" },
    { "value": "1.7", label: "1.7" },
    { "value": "2.1", label: "2.1" },
    { "value": "2.2", label: "2.2" },
    { "value": "2.3", label: "2.3" },
    { "value": "3", label: "3" },
    { "value": "4.1", label: "4.1" },
    { "value": "4.2", label: "4.2" },
    { "value": "4.3", label: "4.3" },
    { "value": "5.1", label: "5.1" },
    { "value": "5.2", label: "5.2" },
    { "value": "6.1", label: "6.1" },
    { "value": "6.2", label: "6.2" },
    { "value": "7", label: "7" },
    { "value": "8", label: "8" },
    { "value": "9", label: "9" },
  ],
  noClaimsBonusOptions: [
    { "value": "", label: "" },
    { "value": "0", label: "Nil - No prior insurance or NCB reduced due to claims" },
    { "value": "20", label: "20% - 1 year claims free" },
    { "value": "30", label: "30% - 2 years claims free" },
    { "value": "40", label: "40% - 3 years claims free" },
    { "value": "50", label: "50% - 4 years claims free" },
  ]
}




